export var Status;
(function (Status) {
    Status[Status["Idle"] = 0] = "Idle";
    Status[Status["Loading"] = 1] = "Loading";
    Status[Status["Error"] = 2] = "Error";
    Status[Status["Success"] = 3] = "Success";
})(Status || (Status = {}));
